import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function ChevronRight(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 36 36" {...props}>
      <path d="M13.4 29.5L25.5 18 13.4 6.5c-.7-.7-1.8-.6-2.4 0-.7.7-.6 1.8 0 2.4l9.5 9.1-9.5 9.1c-.7.7-.7 1.7 0 2.4.6.7 1.7.7 2.4 0z" />
    </SvgIcon>
  )
}
